export default __webpack_public_path__ + "static/media/ProductSans-Bold.46f8236b.woff2";